module.exports = __webpack_public_path__ + "static/img/Group 842@2x.60c71f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20230719/Group 842@2x.png
// module id = opCs
// module chunks = 1